import {request_async} from "@/utils/requestAsync";
import {API_URL_EXP_ADMIN, API_URL_EXP_CONSUMER} from "@/model/ConfigModel";

// 获取一个学校的所有教师id和name列表
export async function getOneSchoolAllTeacherList(schoolId) {
  return request_async(API_URL_EXP_ADMIN + `admin/teacher/oneSchoolAllTeacherList/${schoolId}`, "get", {});
}
